import React, { useContext, useState } from "react";
import { Box, Slide } from "@mui/material";
import { InputField, SIZE } from "@metacrm/metacrm-material-ui/dist/InputField";
import { useIntl } from "react-intl";
import NotificationCenterContext from "features/metadesk/Notification/NotificationCenter/NotificationCenter.context";
import PopperMenuNew from "@metacrm/metacrm-material-ui/dist/PopperMenuNew";
import PopperMenu from "@metacrm/metacrm-material-ui/dist/PopperMenu";
import { Button } from "@metacrm/metacrm-material-ui/dist/Button";
import useNavigateEntity from "hooks/useNavigateEntity";
import CRMTable from "@metacrm/metacrm-material-ui/dist/Table";
import { StyledTableHeader } from "./NotificationCenterContent.styles";
import { map } from "lodash-es";

const NotificationCenterContent = () => {
  const { formatMessage } = useIntl();
  const {
    searchText,
    selectedItems,
    handleSetSelectedItems,
    handleClearSelectedItems,
    notificationList,
    setNotificationList,
    page,
    handleChangePage,
    totalItems,
    handleSearchChange,
    handleCategoryChange,
    renderContents,
    order,
    orderBy,
    handleRequestSort,
    actionsList,
    loading,
    anchorEl,
    handleCloseActions,
  } = useContext(NotificationCenterContext);

  const [totalSelectedAmount, setTotalSelectedAmount] = useState(0);
  const { navigateEntity } = useNavigateEntity();

  const menuItemGroup = [
    {
      menuItemId: "status",
      menuItems: [
        {
          value: "draft",
          label: formatMessage({ id: "global.campaignStatus.draft" }),
        },
        {
          value: "scheduled",
          label: formatMessage({ id: "global.campaignStatus.scheduled" }),
        },
        {
          value: "sent",
          label: formatMessage({ id: "global.campaignStatus.sent" }),
        },
        {
          value: "archived",
          label: formatMessage({ id: "global.campaignStatus.archived" }),
        },
      ],
      canMultiSelect: true,
      onClick: (selected) => handleSetSelectedItems(selected),
    },
  ];

  const handleToCreateCampaignPage = () => {
    navigateEntity(`/notification/notification-detail/create`);
  };

  const headCellsData = [
    {
      show: true,
      disabledSort: false,
      id: "status",
      label: (
        <StyledTableHeader sx={{ paddingLeft: "8px" }}>
          {formatMessage({ id: "global.headline.status" })}
        </StyledTableHeader>
      ),
    },
    {
      show: true,
      disabledSort: false,
      id: "notification",
      label: (
        <StyledTableHeader>
          {formatMessage({ id: "global.module.notification" })}
        </StyledTableHeader>
      ),
    },
    {
      show: true,
      disabledSort: true,
      id: "targetAudience",
      label: (
        <StyledTableHeader>
          {formatMessage({ id: "notification.global.targetAudience" })}
        </StyledTableHeader>
      ),
    },
    {
      show: true,
      disabledSort: true,
      id: "channel",
      label: (
        <StyledTableHeader>
          {formatMessage({ id: "notification.global.channel" })}
        </StyledTableHeader>
      ),
    },
    {
      show: true,
      disabledSort: false,
      id: "sendTime",
      label: (
        <StyledTableHeader>
          {formatMessage({ id: "notification.global.sendTime" })}
        </StyledTableHeader>
      ),
    },

    {
      show: true,
      disabledSort: true,
      id: "actions",
      maxWidth: 80,
      label: (
        <StyledTableHeader>
          {formatMessage({ id: "global.header.actions" })}
        </StyledTableHeader>
      ),
    },
  ];

  const renderFilter = () => {
    return (
      <Box
        sx={{
          paddingTop: "24px",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
        }}
        className="fade-up-more"
      >
        <Box className="startRow" sx={{ flexWrap: "wrap", width: "100%" }}>
          <Box mr={1}>
            <InputField
              size={SIZE.MEDIUM}
              style={{ width: "360px" }}
              startAdornment={
                <i className="meta-crm-icon-ic_search font-size-14" />
              }
              placeholder={formatMessage({
                id: "notification.center.searchPlaceHolder",
              })}
              value={searchText}
              onChange={handleSearchChange}
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
            />
          </Box>

          <Box>
            <PopperMenuNew
              type="filter"
              filterText={formatMessage({ id: "global.filter.filter" })}
              selectedItems={selectedItems}
              totalSelectedAmount={totalSelectedAmount}
              setTotalSelectedAmount={setTotalSelectedAmount}
              onMenuTitleButtonClick={() => {
                handleClearSelectedItems();
              }}
              menuItemGroup={menuItemGroup}
              noBorder
            />
          </Box>

          <Box ml="auto">
            {totalItems}{" "}
            {formatMessage({ id: "notification.center.notificationAmount" })}
          </Box>
        </Box>
      </Box>
    );
  };
  return (
    <div>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        className="fade-up"
      >
        <Box>
          <Box className="title" mb={1}>
            {formatMessage({ id: "global.function.notificationCenter" })}
          </Box>
          <Box color={(theme) => theme.customColors.grey[600]} mb="13px">
            {formatMessage({ id: "notification.center.description" })}
          </Box>
        </Box>
        <Button onClick={handleToCreateCampaignPage}>
          {formatMessage({ id: "notification.btn.create" })}
        </Button>
      </Box>
      {renderFilter()}
      <Box mt={1} className="fade-up-more">
        <CRMTable
          rowData={notificationList}
          headers={headCellsData}
          contents={map(notificationList, (dataItem, i) =>
            renderContents(dataItem)
          )}
          onRequestSort={handleRequestSort}
          onRowClick={(notificationId) => {
            navigateEntity(
              `/notification/notification-detail/${notificationId}`
            );
          }}
          order={order}
          orderBy={orderBy}
          isLoading={loading}
          loadingIndicatorAmount={4}
          dataCounts={totalItems}
          page={page}
          setPage={handleChangePage}
        />
      </Box>

      <PopperMenu
        placement="bottom-end"
        open={Boolean(anchorEl)}
        onClose={handleCloseActions}
        anchorEl={anchorEl}
        itemList={actionsList}
      />
    </div>
  );
};

export default NotificationCenterContent;
